(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@skype/tsregistrar", [], factory);
	else if(typeof exports === 'object')
		exports["@skype/tsregistrar"] = factory();
	else
		root["@skype/tsregistrar"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright (c) Microsoft. All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:no-any
// tslint:disable:export-name
/** Wrapper to send request with specified timeout */
// tslint:disable-next-line:promise-function-async
function fetchWithTimeout(request, timeoutMs) {
    var timeoutId;
    var fetchPromise = new Promise(function (resolve, reject) {
        fetch(request).then(function (response) {
            clearTimeout(timeoutId);
            resolve(response);
        }).catch(function (error) {
            clearTimeout(timeoutId);
            reject(error);
        });
    });
    if (timeoutMs !== 0) {
        var timeoutPromise = new Promise(function (resolve, reject) {
            // tslint:disable-next-line:no-string-based-set-timeout - false positive
            timeoutId = setTimeout(reject, timeoutMs, new Error("Fetch for '" + request.url + "' timed out"));
        });
        return Promise.race([fetchPromise, timeoutPromise]);
    }
    return fetchPromise;
}
exports.fetchWithTimeout = fetchWithTimeout;
function toJson(obj) {
    try {
        return JSON.stringify(obj);
    }
    catch (error) {
        return "Unable to serialize object of type " + typeof obj;
    }
}
exports.toJson = toJson;
/**
 * Simplify calculation of time intervals
 */
var Timespan = /** @class */ (function () {
    function Timespan() {
        this.start = Date.now();
    }
    Object.defineProperty(Timespan.prototype, "duration", {
        /**
         * Returns number of milliseconds from start
         */
        get: function () {
            return Date.now() - this.start;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Timespan.prototype, "startTime", {
        /**
         * Returns start time
         */
        get: function () {
            return this.start;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Reset start of interval to current timestamp
     */
    Timespan.prototype.reset = function () {
        this.start = Date.now();
    };
    return Timespan;
}());
exports.Timespan = Timespan;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Common_1 = __webpack_require__(0);
/**
 * Thrown when retry process was cancelled
 */
var CancelationError = /** @class */ (function (_super) {
    __extends(CancelationError, _super);
    function CancelationError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'CancelationError';
        return _this;
    }
    return CancelationError;
}(Error));
/**
 * Randomized exponential delay used for retries
 */
var ExponentialDelay = /** @class */ (function () {
    function ExponentialDelay(logger, maxBackoffInMs, initialDelay) {
        this.logger = logger;
        this.maxBackoffInMs = maxBackoffInMs;
        this.initialDelay = initialDelay;
        this.backoffCount = 0;
        this.id = ++ExponentialDelay.idCounter;
    }
    // tslint:disable-next-line: promise-function-async
    ExponentialDelay.prototype.delay = function (taskName) {
        var _this = this;
        if (this.timerHandle !== undefined) {
            throw new Error('Retry sequence logical failure');
        }
        if (this.backoffCount === -1) {
            return new Promise(function (resolve, reject) { reject(new CancelationError('Cancelled')); });
        }
        var backoffMs = this.calculateNextBackoffMs();
        this.backoffCount++;
        this.logger.info("[RegistrarClient] Backing off " + taskName + " for " + backoffMs + " milliseconds with ID " + this.id);
        return new Promise(function (resolve, reject) {
            _this.cancelFunc = reject;
            _this.timerHandle = setTimeout(function () {
                _this.logger.info("[RegistrarClient] Back off for " + taskName + " with ID " + _this.id + " complete");
                _this.timerHandle = undefined;
                resolve();
            }, backoffMs);
        });
    };
    ExponentialDelay.prototype.cancel = function () {
        if (this.timerHandle !== undefined) {
            this.logger.debug('Resetting back off');
            clearTimeout(this.timerHandle);
            if (this.cancelFunc !== undefined) {
                this.cancelFunc(new CancelationError('Cancelled'));
            }
        }
        this.backoffCount = -1;
    };
    ExponentialDelay.prototype.calculateNextBackoffMs = function () {
        // tslint:disable-next-line:insecure-random
        var fudge = 1 + (Math.random() - 0.5) * 0.4; // +/- 20%
        var backoff = this.initialDelay * Math.pow(2, this.backoffCount) * fudge;
        backoff = Math.round(backoff);
        return Math.min(this.maxBackoffInMs, backoff);
    };
    ExponentialDelay.idCounter = 0;
    return ExponentialDelay;
}());
/**
 * Registrar client implementation
 */
var RegistrarClient = /** @class */ (function () {
    function RegistrarClient(logger, skypeTokenProvider, options) {
        this.logger = logger;
        this.skypeTokenProvider = skypeTokenProvider;
        this.options = options;
        this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN = 15;
        // Default value for maximum backoff between retries
        this.DEFAULT_MAX_BACKOFF_TIME_IN_MS = 300000; // 5 minutes
        this.backoffs = {};
        this.maxBackOffTime =
            this.options.maxRetryDelayMs > 0
                ? this.options.maxRetryDelayMs
                : this.DEFAULT_MAX_BACKOFF_TIME_IN_MS;
        this.maxRetriesForGetToken =
            options.maxRetriesForGetToken === undefined ||
                options.maxRetriesForGetToken === null
                ? this.DEFAULT_MAX_RETRIES_FOR_GET_TOKEN
                : options.maxRetriesForGetToken;
    }
    RegistrarClient.prototype.setTelemetryLogger = function (eventLogger) {
        this.eventLogger = eventLogger;
    };
    RegistrarClient.prototype.register = function (client, transports) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.performRegistration(client, transports, 'pr_set_registration')];
                    case 1:
                        _a.sent();
                        this.cachedRegistrationParams = [client, transports];
                        return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.unregister = function () {
        return __awaiter(this, void 0, void 0, function () {
            var unregisterRequest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info('[RegistrarClient] sending unregister request');
                        unregisterRequest = new Request(this.options.registrarUrl + "/" + this.options.registrationId, {
                            method: 'DELETE',
                            mode: 'cors',
                            headers: new Headers({
                                accept: 'application/json, text/javascript'
                            })
                        });
                        return [4 /*yield*/, this.callRegistrar(unregisterRequest, 'pr_delete_registration')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.cancelPendingRequests = function () {
        var _this = this;
        Object.keys(this.backoffs).forEach(function (id) {
            _this.backoffs[id].cancel();
        });
        this.backoffs = {};
    };
    RegistrarClient.prototype.resendRegistration = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.cachedRegistrationParams) {
                            throw new Error('Re-registration failed because there is no registration parameters cached');
                        }
                        return [4 /*yield*/, this.performRegistration(this.cachedRegistrationParams[0], this.cachedRegistrationParams[1], 'pr_resend_registration')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.performRegistration = function (client, transports, eventName) {
        return __awaiter(this, void 0, void 0, function () {
            var payload, registerRequest;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info('[RegistrarClient] Sending register request');
                        payload = {
                            clientDescription: client,
                            registrationId: this.options.registrationId,
                            nodeId: '',
                            transports: transports
                        };
                        registerRequest = new Request(this.options.registrarUrl, {
                            method: 'POST',
                            mode: 'cors',
                            headers: new Headers({
                                'content-type': 'application/json',
                                accept: 'application/json, text/javascript'
                            }),
                            body: Common_1.toJson(payload)
                        });
                        return [4 /*yield*/, this.callRegistrar(registerRequest, eventName)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.startBackoff = function () {
        var backoff = new ExponentialDelay(this.logger, this.maxBackOffTime, this.options.initialRetryDelayMs);
        this.backoffs[backoff.id] = backoff;
        return backoff;
    };
    RegistrarClient.prototype.stopBackoff = function (backoff) {
        backoff.cancel();
        delete this.backoffs[backoff.id];
    };
    RegistrarClient.prototype.getSkypeToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var backoff, retryCount, token, error_1, stringfiedError, err, cancelError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        backoff = this.startBackoff();
                        retryCount = 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 8]);
                        this.logger.info('[RegistrarClient] Asking for a new skypetoken');
                        return [4 /*yield*/, this.skypeTokenProvider(true)];
                    case 2:
                        token = _a.sent();
                        this.stopBackoff(backoff);
                        return [2 /*return*/, token];
                    case 3:
                        error_1 = _a.sent();
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        retryCount++;
                        stringfiedError = JSON.stringify(error_1);
                        if (retryCount > this.maxRetriesForGetToken) {
                            err = "[RegistrarClient] getSkypeToken retry limit hit. Will not retry now. Error: " + stringfiedError;
                            this.logger.error(err);
                            this.stopBackoff(backoff);
                            return [2 /*return*/, Promise.reject(err)];
                        }
                        this.logger.warn("[RegistrarClient] Retrying for a new skype token. Retry Count: " + retryCount + " Error: " + stringfiedError);
                        return [4 /*yield*/, backoff.delay('Fetching a new skypetoken')];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 6:
                        cancelError_1 = _a.sent();
                        this.stopBackoff(backoff);
                        throw cancelError_1;
                    case 7: return [3 /*break*/, 8];
                    case 8: return [3 /*break*/, 1];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.callRegistrar = function (request, eventName) {
        return __awaiter(this, void 0, void 0, function () {
            var backoff, cachedSkypetoken, stopwatch, retryCount, response, req, err, _a, _b, error_2, canceledError_1, details, _c, _d, error_3, message;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        backoff = this.startBackoff();
                        return [4 /*yield*/, this.skypeTokenProvider(false)];
                    case 1:
                        cachedSkypetoken = _e.sent();
                        this.setSkypeTokenHeader(request, cachedSkypetoken);
                        stopwatch = new Common_1.Timespan();
                        retryCount = 0;
                        _e.label = 2;
                    case 2:
                        response = void 0;
                        _e.label = 3;
                    case 3:
                        _e.trys.push([3, 8, 13, 14]);
                        req = request.clone();
                        return [4 /*yield*/, Common_1.fetchWithTimeout(req, this.options.requestTimeoutMs)];
                    case 4:
                        response = _e.sent();
                        if (!(response.status === 401)) return [3 /*break*/, 6];
                        retryCount++;
                        if (retryCount > this.maxRetriesForGetToken) {
                            err = "[RegistrarClient] getSkypeToken retry limit hit. Will not retry now. Request '" + request.url + "' failed with " + response.status + " " + response.statusText;
                            this.logger.error(err);
                            this.stopBackoff(backoff);
                            return [2 /*return*/, Promise.reject(err)];
                        }
                        this.logger.warn("[RegistrarClient] Retry Count " + retryCount + ". Request '" + request.url + "' failed with " + response.status + " " + response.statusText);
                        _a = this.setSkypeTokenHeader;
                        _b = [request];
                        return [4 /*yield*/, this.getSkypeToken()];
                    case 5:
                        _a.apply(this, _b.concat([_e.sent()]));
                        //should we wait before retrying with a new skypetoken?
                        return [3 /*break*/, 20];
                    case 6:
                        if (response.status >= 500 && response.status < 600) {
                            // throw and retry after in the catch section
                            throw new Error("Fetch for '" + request.url + "' failed with " + response.status + " " + response.statusText);
                        }
                        _e.label = 7;
                    case 7: return [3 /*break*/, 14];
                    case 8:
                        error_2 = _e.sent();
                        this.logger.error("[RegistrarClient] Request failed with " + error_2);
                        _e.label = 9;
                    case 9:
                        _e.trys.push([9, 11, , 12]);
                        // retry on network errors (thrown by fetch) and retryable codes
                        return [4 /*yield*/, backoff.delay('Registrar call retry')];
                    case 10:
                        // retry on network errors (thrown by fetch) and retryable codes
                        _e.sent();
                        return [3 /*break*/, 20];
                    case 11:
                        canceledError_1 = _e.sent();
                        this.logger.error('[RegistrarClient] Request cancelled');
                        this.stopBackoff(backoff);
                        throw canceledError_1;
                    case 12: return [3 /*break*/, 14];
                    case 13:
                        this.sendTelemetryEvent(eventName, request, response, stopwatch);
                        return [7 /*endfinally*/];
                    case 14:
                        this.stopBackoff(backoff);
                        if (!response.ok) return [3 /*break*/, 15];
                        return [2 /*return*/, response];
                    case 15:
                        details = void 0;
                        _e.label = 16;
                    case 16:
                        _e.trys.push([16, 18, , 19]);
                        _d = (_c = JSON).stringify;
                        return [4 /*yield*/, response.json()];
                    case 17:
                        details = _d.apply(_c, [_e.sent()]);
                        return [3 /*break*/, 19];
                    case 18:
                        error_3 = _e.sent();
                        details = 'no details';
                        return [3 /*break*/, 19];
                    case 19:
                        message = "Fetch for '" + request.url + "' failed with " + response.status + " " + response.statusText + " (" + details + ", MS-CV: " + response.headers.get('MS-CV') + ")";
                        this.logger.error("[RegistrarClient] " + message);
                        throw new Error(message);
                    case 20: return [3 /*break*/, 2];
                    case 21: return [2 /*return*/];
                }
            });
        });
    };
    RegistrarClient.prototype.setSkypeTokenHeader = function (request, skypetoken) {
        // tslint:disable-next-line: no-backbone-get-set-outside-model
        request.headers.set('X-Skypetoken', skypetoken);
    };
    RegistrarClient.prototype.sendTelemetryEvent = function (eventName, request, response, stopwatch) {
        if (this.eventLogger === undefined) {
            return;
        }
        var clientEvent = {
            name: eventName,
            properties: {
                url: { value: request.url },
                result_code: { value: response !== undefined ? response.status : 0 },
                begin_timestamp: { value: stopwatch.startTime },
                elapsed: { value: stopwatch.duration }
            }
        };
        this.eventLogger.logEvent(clientEvent);
    };
    return RegistrarClient;
}());
exports.RegistrarClient = RegistrarClient;
function createRegistrarClient(logProvider, skypeTokenProvider, options) {
    return new RegistrarClient(logProvider, skypeTokenProvider, options);
}
exports.createRegistrarClient = createRegistrarClient;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// tsregistrar.js